<div class="flex flex-column w-100">
  <div class="box-body table-responsive white" [formGroup]="filterFormGroup">
    <gp-table class="table table-hover">
      <colgroup>
        <col class="w"><!-- TYPE -->
        <col><!-- DETAILS -->
        <col><!-- REQUESTER -->
        <col><!-- SUBJECT -->
        <col class="w"><!-- STATUS -->
        <col><!-- ASSIGNEE -->
        <col class="w-sm"><!-- STARTED ON -->
        <col class="w-sm"><!-- ENDED ON -->
        <col class="w-50"><!-- ACTIONS -->
      </colgroup>
      <thead gp-table-head>
      <tr role="heading">
        <th colspan="9" scope="row">
          <div class="pull-right p-a-xs">
            <button (click)="resetFilters()"
                    class="btn btn-xs btn-outline-primary"
                    test-id="clear-all-filters"
                    type="button">
              <em class="fa fa-light fa-filter-circle-xmark"></em>
              <span class="m-l-xs">{{'CONTEXT_BAR.clear_all_filters' | translate}}</span>
            </button>
          </div>
        </th>
      </tr>
      <tr role="heading">
        <th class="text-uppercase va-baseline" gp-table-column scope="col"
            test-id="type-header">{{ 'WORKFLOWS.type' | translate }}</th>
        <th class="text-uppercase va-baseline" gp-table-column scope="col"
            test-id="details-header">{{ 'WORKFLOWS.details' | translate }}</th>
        <th class="text-uppercase va-baseline" gp-table-column scope="col"
            test-id="requester-header">{{ 'WORKFLOWS.requester' | translate }}</th>
        <th class="text-uppercase va-baseline" gp-table-column scope="col"
            test-id="subject-header">{{ 'WORKFLOWS.subject' | translate }}</th>
        <th class="text-uppercase va-baseline" gp-table-column scope="col"
            test-id="status-header">{{ 'WORKFLOWS.status' | translate }}</th>
        <th class="text-uppercase min-width-sm va-baseline" gp-table-column scope="col"
            test-id="assignee-header">{{ 'WORKFLOWS.assignee' | translate }}</th>
        <th class="text-uppercase min-width-xs va-baseline" gp-table-column scope="col"
            test-id="creationDate-header">{{ 'WORKFLOWS.started_on' | translate }}</th>
        <th class="text-uppercase min-width-xs va-baseline" gp-table-column scope="col"
            test-id="creationDate-header">{{ 'WORKFLOWS.ended_on' | translate }}</th>
        <th class="text-uppercase va-baseline" gp-table-column scope="col"
            test-id="reassign-header"></th>
      </tr>
      <tr role="heading">
        <td>
          <ng-select [attr.test-id]="'type-filter'"
                     [idField]="'key'"
                     [textField]="'key'"
                     [items]="workflowTypes"
                     [placeholder]="'WORKFLOWS.type' | translate "
                     [sortByTranslationsEnabled]="false"
                     class="form-control"
                     formControlName="type"
                     ngDefaultControl
          >
          </ng-select>
        </td>
        <td><!-- DETAILS --></td>
        <td>
          <input [attr.test-id]="'requester-filter'"
                 class="form-control"
                 formControlName="requester"
                 placeholder="{{'WORKFLOWS.requester' | translate}}"
                 type="text">
        </td>
        <td>
          <input [attr.test-id]="'subject-filter'"
                 class="form-control"
                 formControlName="subject"
                 placeholder="{{'WORKFLOWS.subject' | translate}}"
                 type="text">
        </td>
        <td>
          <ng-select [attr.test-id]="'status-filter'"
                     [idField]="'key'"
                     [textField]="'name'"
                     [items]="WORKFLOW_STATUS"
                     [placeholder]="'WORKFLOWS.status' | translate"
                     [sortByTranslationsEnabled]="false"
                     class="form-control"
                     formControlName="status"
                     ngDefaultControl
          >
          </ng-select>
        </td>
        <td><!-- ASSIGNEE --></td>
        <td><!-- CREATION DATE --></td>
        <td><!-- FINISH DATE --></td>
        <td><!--  --></td>
      </tr>
      </thead>
      <tbody>
      <tr *ngIf="loading">
        <td colspan="9" class="text-center">
          <div class="skeleton-block">
            <p>
              <skeleton-block width="100%" height="30px" [effect]="'wave'" borderRadius="4"></skeleton-block>
            </p>
            <p>
              <skeleton-block width="100%" height="30px" [effect]="'wave'" borderRadius="4"></skeleton-block>
            </p>
            <p>
              <skeleton-block width="100%" height="30px" [effect]="'wave'" borderRadius="4"></skeleton-block>
            </p>
          </div>
        </td>
      </tr>
      <tr *ngIf="!loading && !tasks?.length" class="noContent">
        <td colspan="9" class="text-center p-t-lg p-b-lg">
          <gp-illustrated-message [text]="'WORKFLOWS.no_task'" [width]="'30%'"></gp-illustrated-message>
        </td>
      </tr>
      <tr *ngFor="let task of tasks trackBy: trackByTaskId"
          (click)="viewTask(task, $event)"
          [class.pointer]="task.status === 'IN_PROGRESS'"
          [class.task-selected]="task.status === 'IN_PROGRESS' && taskIdLastViewed === task.id"
          [class.task-not-viewed]="task.status === 'IN_PROGRESS' && !task.read">
        <td test-id="task-type">{{task?.type | translate}}</td>
        <td test-id="task-details">{{task.details ? (task.details | translate) : '-'}}</td>
        <td>
          <div>
            <span [attr.test-id]="'requester-full-name'">{{task?.requester?.fullName}}</span>
            <span *ngIf="task?.requester?.employeeNumber" [attr.test-id]="'requester-employee-number'"
                  class="text-muted">&nbsp;({{task?.requester?.employeeNumber}})</span>
          </div>
        </td>
        <td>
          <div>
                <span
                  [attr.test-id]="'subject-full-name'">{{task?.subject?.fullName ? task?.subject?.fullName : '-'}}</span>
            <span *ngIf="task?.subject?.employeeNumber"
                  [attr.test-id]="'subject-employee-number'"
                  class="text-muted">&nbsp;({{task?.subject?.employeeNumber}})</span>
          </div>
        </td>
        <td>
          <gp-workflow-status [status]="task.status"></gp-workflow-status>
        </td>
        <td>
          <ng-container *ngIf="task?.assignee else noAssignee">
            <div>
              <span [attr.test-id]="'assignee-full-name'">{{task?.assignee?.fullName}}</span>
              <span *ngIf="task?.assignee?.employeeNumber"
                    [attr.test-id]="'assignee-employee-number'"
                    class="text-muted">&nbsp;({{task?.assignee?.employeeNumber}})</span>
            </div>
          </ng-container>
          <ng-template #noAssignee>
            <ng-container *ngIf="task?.candidates?.length else noCandidates">
              <div *ngFor="let candidate of task?.candidates; let index = index">
                <span [attr.test-id]="'candidate-' + index + '-full-name'">{{candidate?.fullName}}</span>
                <span *ngIf="candidate?.employeeNumber"
                      [attr.test-id]="'candidate-' + index + '-employee-number'"
                      class="text-muted">&nbsp;({{candidate?.employeeNumber}})</span>
              </div>
            </ng-container>
          </ng-template>
          <ng-template #noCandidates>
            <div>-</div>
          </ng-template>
        </td>
        <td test-id="task-start-time">{{task?.startTime | gpDate: {withHour: true}: (trigger$|async)}}</td>
        <td test-id="task-end-time">{{task?.endTime | gpDate: {withHour: true}: (trigger$|async)}}</td>
        <td *ngIf="{ opened: false } as contextMenu">
          <div (click-outside)="contextMenu.opened = false"
               [class.open]="contextMenu.opened"
               *ngIf="task.status === 'IN_PROGRESS' && canReassign"
               class="dropdown">
            <button (click)="contextMenu.opened = !contextMenu.opened"
                    class="btn btn-outline btn-xs btn-context-menu"
                    type="button">
              <span class="fa fa-light fa-ellipsis-v"></span>
            </button>
            <ul #rowActionContextMenu
                (click)="contextMenu.opened = false"
                *ngIf="contextMenu.opened"
                class="dropdown-menu pull-right dropdown-menu-scale">
              <li (click)="openReassignRequestModal(task)" class="dropdown-item">
                <i aria-hidden="true"></i>
                <span>{{ 'WORKFLOWS.reassign' | translate }}</span>
              </li>
            </ul>
          </div>
        </td>
      </tr>
      </tbody>
    </gp-table>
  </div>
  <gp-table-pagination
    (pageChange)="refreshTasks()"
    [pagination]="pagination"
    [text]="'WORKFLOWS.showing___of_tasks'">
  </gp-table-pagination>

  <gp-side-panel [isSidePanelOpen]="!!taskIdLastViewed"
                 (isSidePanelOpenChange)="closeSidePanel($event)"
                 [sidePanelTitle]="('WORKFLOWS.taskDetails' | translate)">
    <router-outlet></router-outlet>
  </gp-side-panel>

</div>

